import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import verifyUser from '../../services/verifyUser';
import { trackPageView, trackGaEvent } from '../../services/tracking';
import { validateZipcode } from '../../utils/validators';

import { Button } from '../button';
import { Input } from '../input';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';

const Profile = (props) => {
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);
  const initialValues = { ...subscription };

  const validate = (values) => {
    let errors = {};

    if(!values.email){
      errors.email = 'Digite o seu email';
    }
    else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)){
      errors.email = 'Digite um email válido';
    }

    if (!values.zipcode){
      errors.zipcode = 'Digite o seu CEP';
    }
    else if(!validateZipcode(values.zipcode)){
      errors.zipcode = 'Digite um CEP válido';
    }

    // if (!values.name){
    //   errors.name = 'Digite o seu nome completo';
    // }
    // else if(!validateName(values.name)){
    //   errors.name = 'Digite um nome válido';
    // }

    return errors;
  }

  const handleSubmit = (values) => {
    dispatch(updateSubscription({
      name: values.name,
      email: values.email,
      zipcode: values.zipcode,
    }));

    dispatch(completeStep(1));

    props.history.push('/plano-gateway');
  }

  const handleEmailBlur = (e) => {
    verifyEmail(e.target.value);
  }

  const verifyEmail = (email) => {
    if(email) verifyUser({ email });
  }

  useEffect(() => {
    verifyEmail(subscription.email);

    trackPageView();
    trackGaEvent('begin_checkout');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={validate}
      >
        <Form>
          <PageHeader>
            <small>Dados pessoais</small>
            <h1>Comece nos dizendo quem você é</h1>
            <p>vamos começar a montar o seu pedido perfeito!</p>
          </PageHeader>

          {/* <Input name="name" label="Nome" /> */}
          <Input name="email" label="Email" type="email" onBlur={handleEmailBlur} />
          <Input name="zipcode" label="CEP" format="#####-###" />

          <FormActions>
            <Button
              type="submit"
              icon="angle-right"
              align="right"
              description="Sua caixinha"
            >
              Continuar
            </Button>
          </FormActions>
        </Form>
      </Formik>
    </div>
  )
}

export default withRouter(Profile);
